<template>
  <div class="CreateSubfolderFormComponent">

    

      <b-form-group id="input-group-Name" :label="lang.label_Name" label-for="input-2">
        <b-form-input
          id="input-Name"
          v-model="form.name"
          :placeholder="lang.placeholder_Name"
          size="sm"
          required
          aria-describedby="input-Name-feedback"
          :state="validation_Name"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Name-feedback" :state="validation_Name">
          {{lang.validinfo_Name}}
        </b-form-invalid-feedback>
      </b-form-group>

      

    
  </div>
</template>

<script>


export default {
  name: "CreateSubfolderFormComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        name: '',
        
        
      },
      inputStatus: null,
      
    }
  },
  computed: {
    validation_Name() {
      
      let index = this.form.name.indexOf("\\")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("/")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf(":")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("*")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("?")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("\"")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("<")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf(">")
      if (index > -1){
        return false;
      }
      index = this.form.name.indexOf("|")
      if (index > -1){
        return false;
      }
      return this.form.name.length > 0
    },
    
    
  },
  created() {


  },
  updated(){
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_createSubfolderForm", this.form)
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .CreateSubfolderFormComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CreateSubfolderFormComponent.vue